import WorthyApi from 'lib/api/worthyApi';
import rootStore from 'reducers';
import { session } from 'actions/session';
import { Authenticator } from 'lib/api/authenticator'

export const ADO = Symbol('ADO');

export function ado() {
    let request =
        WorthyApi.ado()
            .then((response)=>{
                if (response.data.user) {
                    rootStore.dispatch(session(response.data.user));
                } else {
                    rootStore.dispatch(session(null));
                }
                if (response.data.shouldRefreshToken) {
                    Authenticator.refreshToken().then(() => rootStore.dispatch(ado()))
                }
                
                return response;
            })
            .catch((error)=>{
                throw error;
            });

    return {
        type:       ADO,
        payload:    request
    }
}